export const REQUIRED = 'Este campo es requerido'
export const NUMBER = 'Debe ingresar un número válido'
export const INTEGER = 'El número no puede contener decimales'
export const EMAIL = 'Debe ingresar  un email válido'
export const NO_NEG = 'Debe ingresar un valor positivo'
export const MIN_LENGTH = (length) => `Este campo debe contener al menos ${length} caracteres`
export const MAX_LENGTH = (length) => `Este campo no debe contener mas de ${length} caracteres`
export const MIN = (min) => `El valor minimo es ${min}`
export const MAX = (max) => `El valor máximo es ${max}`